import type { useNotCompletedNotificationValues } from './hooks/useNotCompletedNotificationValues'

export function convertValues(formValues: ReturnType<typeof useNotCompletedNotificationValues>) {
  return {
    ...formValues,
    includeMessageUnsubscriptionInstructions:
      formValues.notificationWay === 'EMAIL'
        ? formValues.includeMessageUnsubscriptionInstructionsEmail
        : formValues.includeMessageUnsubscriptionInstructionsPhone,
  }
}
